export const pillTokens = {
  base:
    'inline-flex items-center justify-center min-h-[44px] px-3 py-1.5 md:px-4 rounded-xl font-semibold text-xs whitespace-nowrap border-2 shrink-0 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-inset',
  active: 'bg-primary text-white border-primary shadow-md shadow-primary/20',
  inactive:
    'bg-gray-50 dark:bg-gray-700 text-gray-600 dark:text-gray-300 border-transparent hover:bg-gray-100 dark:hover:bg-gray-600',
  more: 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 border-transparent hover:bg-gray-200 dark:hover:bg-gray-600',
  chip:
    'inline-flex items-center justify-center min-h-[44px] text-xs px-3 py-1.5 rounded-full border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:border-primary hover:text-primary transition-colors',
};
